module.exports = __webpack_public_path__ + "img/img_64.41786cac.png";